import React from "react";


const ReturnToWork = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path d="M19.0312 6.09377L15 2.81252C14.6562 2.53127 14.2187 2.50002 13.8437 2.68752C13.4687 2.87502 13.2187 3.25002 13.2187 3.68752V6.25002H5.90625C2.96875 6.25002 0.5625 8.75002 0.5625 11.8438C0.5625 14.9375 2.96875 17.4375 5.90625 17.4375H10.125C10.5 17.4375 10.8437 17.125 10.8437 16.7188C10.8437 16.3125 10.5312 16 10.125 16H5.90625C3.71875 16 1.96875 14.125 1.96875 11.8125C1.96875 9.50002 3.75 7.62502 5.90625 7.62502H13.2187V10.1875C13.2187 10.625 13.4687 11 13.8437 11.1875C14 11.25 14.1562 11.2813 14.3125 11.2813C14.5625 11.2813 14.8125 11.1875 15 11.0313L19.0312 7.78127C19.2812 7.56252 19.4375 7.25002 19.4375 6.93752C19.4687 6.59377 19.3125 6.28127 19.0312 6.09377ZM14.625 9.56252V4.31252L17.875 6.93752L14.625 9.56252Z" fill="currentColor" />
        </svg>
    );
};

export default ReturnToWork;


